import React, { useState } from "react";
import Popup from "./Popup";
import { hidePopup } from "./BasePopup";
import classnames from "class-names";

const CancelConfirmationContent = ({ onNo, onYes, deleteUrl }) => (
  <div className="popup-cancel-appointment__actions-block popup-cancel-appointment__actions-block_width_small">
    <a
      href={deleteUrl}
      onClick={e => {
        onYes && onYes();
        e.preventDefault();
        const axios = require('axios');
        const url = deleteUrl
          axios.get(url)
          .then(function (response) {
            console.log('Ok');
          })
          .catch(function (error) {
            console.log(error);
          });
      }}
      className="button button_large"
    >
      Отменить заявку
    </a>
    <a
      href="#"
      onClick={e => {
        onNo && onNo();
        e.preventDefault();
      }}
      className="button button_blue-border button_large"
    >
      Продолжить
    </a>
  </div>
);

const CanceledContent = ({newUrl, editUrl, showUrl}) => (
  <div>
    <div className="popup-cancel-appointment__message">
      Если вы отменили заявку случайно, то&nbsp;нажмите «Создать новую заявку»
    </div>
    <div className="popup-cancel-appointment__actions-block popup-cancel-appointment__actions-block_width_large">
      <a
        href={editUrl}
        className="button button_large"
      >
        Изменить
      </a>
      <a
        href={newUrl}
        className="button button_blue-border button_large"
      >
        Создать новую заявку
      </a>
    </div>
  </div>
);

const CancelAppointmentPopup = ({ name, newUrl, editUrl, deleteUrl, showUrl }) => {
  const [canceled, setCanceled] = useState(false);

  return (
    <Popup
      name={name}
      className={classnames("popup-cancel-appointment", {
        "popup-cancel-appointment_space-b_small": canceled
      })}
      onHide={() => setCanceled(false)}
      header={
        canceled
          ? "Ваша заявка отменена"
          : "Вы действительно хотите отменить заявку?"
      }
    >
      {canceled ? (
        <CanceledContent newUrl={newUrl} editUrl={editUrl} showUrl={showUrl} />
      ) : (
        <CancelConfirmationContent
          deleteUrl={deleteUrl}
          onYes={() => setCanceled(true)}
          onNo={() => hidePopup(name)}
        />
      )}
    </Popup>
  );
};
export default CancelAppointmentPopup;
